// Rate limiting utility functions
const SUBMISSION_COOLDOWN = 60000; // 1 minute in milliseconds

export const checkRateLimit = actionKey => {
  const lastActionTime = parseInt(localStorage.getItem(actionKey)) || 0;
  const now = Date.now();
  const timeSinceLastAction = now - lastActionTime;

  if (timeSinceLastAction < SUBMISSION_COOLDOWN) {
    return {
      allowed: false,
      remainingTime: Math.ceil((SUBMISSION_COOLDOWN - timeSinceLastAction) / 1000),
    };
  }

  return { allowed: true, remainingTime: 0 };
};

export const updateRateLimit = actionKey => {
  localStorage.setItem(actionKey, Date.now().toString());
};

export const RATE_LIMIT_KEYS = {
  CONTACT_FORM: 'lastFormSubmission',
  FEATURE_REQUEST: 'lastFeatureRequest',
};
